/**
 * The Composer's Remix pop-up (Dax, 2026-10-04): the platform and its length in the title, one row of
 * sounds to make it with, and Continue. The remix is a new composition; the one on screen is untouched.
 */
import { useState } from 'react';
import { REMIX_PRESETS, type ComposeRemixTarget, type RemixAudio } from '@studio/contracts';

const AUDIO_LABELS: Record<RemixAudio, string> = { music: 'Trending music', asmr: 'ASMR', voice: 'Voiceover' };

export function ComposeRemixModal({ target, initial, pending, error, onGo, onClose }: {
  target: ComposeRemixTarget;
  /** The sound offered first. */
  initial: RemixAudio;
  pending: boolean;
  error: string | null;
  onGo: (audio: RemixAudio) => void;
  onClose: () => void;
}) {
  const preset = REMIX_PRESETS[target];
  const [audio, setAudio] = useState<RemixAudio>(initial);
  const secs = (ms: number | null) => Math.round((ms ?? 0) / 1000);
  return (
    <>
      <button type="button" className="overlay overlay-btn" aria-label="Close" onClick={onClose} />
      <div className="modal compose-remix-modal" role="dialog" aria-label={`${preset.platform} remix`}>
        <h2>{preset.platform} · {secs(preset.minMs)} to {secs(preset.maxMs)} s</h2>
        <div className="row remix-audio" role="radiogroup" aria-label="Sound">
          {(Object.keys(AUDIO_LABELS) as RemixAudio[]).map((a) => (
            <label key={a}>
              <input type="radio" name="remix-audio" value={a} checked={audio === a} onChange={() => setAudio(a)} />
              {AUDIO_LABELS[a]}
            </label>
          ))}
        </div>
        {error && <div className="error" role="alert">{error}</div>}
        <div className="row between">
          <button type="button" className="btn quiet" onClick={onClose}>Cancel</button>
          <button type="button" className="btn primary" disabled={pending} onClick={() => onGo(audio)}>{pending ? 'Remixing…' : 'Continue'}</button>
        </div>
      </div>
    </>
  );
}
